// Combining marks U+0300 to U+036F: stripped after NFKD decomposition so accented
// characters collapse to their base form for the slug.
// biome-ignore lint/suspicious/noMisleadingCharacterClass: the range is intentional - matches only combining marks, applied after NFKD decomposition
const DIACRITICS = /[\u0300-\u036F]/g;
const NON_SLUG = /[^a-z0-9]+/g;
const SLUG_EDGES = /^-+|-+$/g;
/**
 * Lowercase, kebab-case slug for the address-detail URL. Lossy by design:
 * we re-geocode on every visit, so the slug only needs to be a stable,
 * URL-safe representation of the user-facing address string.
 */
export function formatAddressSlug(formattedAddress) {
    return formattedAddress
        .normalize('NFKD')
        .replace(DIACRITICS, '')
        .toLowerCase()
        .replace(NON_SLUG, '-')
        .replace(SLUG_EDGES, '');
}
/**
 * Inverse of the lossy slug for geocoding: hyphens -> spaces. The geocoder
 * is responsible for restoring punctuation.
 */
export function slugToQuery(slug) {
    return slug.replace(/-+/g, ' ').trim();
}
//# sourceMappingURL=slug.js.map